import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function HeroSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="relative pt-14 pb-0 px-4 md:pt-24 md:pb-0 overflow-hidden bg-gradient-to-b from-[#EEF6FB] to-white" data-id="element-106">
      <div ref={ref} className={`max-w-3xl mx-auto text-center ${isVisible ? 'reveal-visible' : 'reveal-hidden'}`} data-id="element-107">
        <h1 className="text-[2.25rem] md:text-5xl lg:text-[3.5rem] text-[#2D2D2D] mb-8 leading-[1.25] tracking-tight" data-id="element-108">
          <span className="font-normal" data-id="element-109">Transforma la</span>
          <br data-id="element-110" />
          <span className="font-extrabold italic text-[#D32F2F]" data-id="element-111">
            inseguridad
          </span>{' '}
          <span className="font-normal" data-id="element-112">de tu hijo</span>
          <br data-id="element-113" />
          <span className="font-normal" data-id="element-114">a la </span>
          <span className="font-extrabold" data-id="element-115">hora de leer</span>
          <span className="font-normal" data-id="element-116"> en</span>
          <br data-id="element-117" />
          <span className="italic text-[#2E7D32] font-bold" data-id="element-118">
            Fluidez Lectora
          </span>
          <br data-id="element-119" />
          <span className="italic font-medium underline underline-offset-[6px] decoration-[2.5px] decoration-[#2D2D2D]" data-id="element-120">
            en 14 días
          </span>
        </h1>
      </div>

      {/* Hero Image */}
      <div className="mt-6 max-w-5xl mx-auto relative" data-id="element-121">
        <img src="https://cdn.magicpatterns.com/uploads/hyGSDgF8CiC1YBJRLFoPMV/Diseno_sin_titulo.png" alt="MegaKit Lectura Feliz - Más de 100 actividades divertidas" className="w-full h-auto drop-shadow-2xl" data-id="element-122" />

        {/* Floating rating badge */}
        <div className="absolute -bottom-5 -right-4 bg-white py-3 px-4 rounded-2xl shadow-lg border border-gray-100 hidden md:block" data-id="element-123">
          <div className="flex items-center gap-2" data-id="element-124">
            <div className="text-yellow-400 text-sm tracking-tight" data-id="element-125">★★★★★</div>
            <span className="font-bold text-gray-700 text-sm" data-id="element-126">4.9/5</span>
          </div>
        </div>
      </div>

      {/* CTA Button - below image */}
      <div className="mt-12 flex flex-col items-center" data-id="element-127"></div>
    </section>;
}